import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, Input, OnDestroy } from '@angular/core';
import { Subject, Observable, map, takeUntil } from 'rxjs';
import { ResponsiveService } from '../../responsive.service';
import { AuthService } from '../../authentication/auth.service';
import { AccessControl } from '../../authentication/access-control';

@Component({
  selector: 'app-card-wrapper',
  imports: [AsyncPipe],
  standalone: true,
  templateUrl: './card-wrapper.component.html',
  styleUrl: '../balsa-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardWrapperComponent implements OnDestroy{
  private readonly responsiveService = inject(ResponsiveService);
  private readonly auth = inject(AuthService);
  useMarginBottom = input<boolean>(true);

  get marginBottom() {
    const hasChatBot = this.auth.hasAnyPermission(...AccessControl.FeatureAnySupportChatBot);
    if (!this.useMarginBottom()) {
      return '0';
    }

    return hasChatBot ? '6rem' : '0';
  }

  /** Centers the card in the view in a responsive manner */
  @Input() centered = false;
  destroy = new Subject<void>();
  responsiveClass: Observable<string> = this.responsiveService.subject.pipe(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    map((state) => {
      if (state.isLargeIsh && state.isWeb) return 'large';
      return 'small';
    }),
    takeUntil(this.destroy),
  );

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }
}
